import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {z} from 'zod';

export const CohortUserCreatedPropertiesSchema = z.object({});
export type CohortUserCreatedProperties = z.infer<typeof CohortUserCreatedPropertiesSchema>;

export type CohortUserCreatedEventStruct = UserEventStruct<
  'cohort.user.created',
  CohortUserCreatedProperties
>;

export const CohortUserCreatedEventSpec: UserEventSpec<CohortUserCreatedEventStruct> = {
  id: 'cohort.user.created',
  propertiesSchema: CohortUserCreatedPropertiesSchema,
  rulesEngineConfig: {
    isVisible: false,
    exposedFields: {},
  },
};
